import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import { HashRouter } from 'react-router-dom';

import './index.css';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import './services/sentry';
import App from './App';
import ErrorBoundaryPage from './components/ErrorBoundaryPage';
import i18nUI from './translation/i18nUI';

createRoot(document.getElementById('root')!).render(
  <I18nextProvider i18n={i18nUI}>
    <ErrorBoundary fallback={<ErrorBoundaryPage />}>
      <HashRouter>
        <App />
      </HashRouter>
    </ErrorBoundary>
  </I18nextProvider>,
);
